<template>
  <div class="bottom-wrap" :class="className">
    <el-button @click="onDefaultFun" v-if="showDefaultBtn">{{ defaultText }}</el-button>
    <el-button class="pc-btn" type="primary" @click="btnClick" :disabled="disabled">{{ labelData[mode] || labelData['add'] }}</el-button>
  </div>

</template>

<script>
export default {
  name: 'BottomButton',
  props: {
    // add   edit  agree
    mode: {
      type: String,
      default: "add"
    },

    label: {
      type: String,
      default: ""
    },

    disabled: {
      type: Boolean,
      default: false
    },

    showDefaultBtn: {
      type: Boolean,
      default: false
    },

    defaultText: {
      type: String,
      default: "Previous"
    },

    customLeftBtnClick: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: ""
    }

  },
  data() {
    return {
      labelData: {
        add: this.label ? this.label : this.$t('APP-FIELD-0140'),
        edit: this.$t('APP-FIELD-0132'),
        agree: this.$t('APP-FIELD-0118'),
        check: 'Check Application Status',
      }
    };
  },
  methods: {
    onDefaultFun() {
      if (this.customLeftBtnClick) {
        this.$emit('leftBtnClick')
      } else {
        this.$router.go(-1)
      }
    },

    btnClick() {
      this.$emit('click')
    },
  },
  watch: {
    mode(newValue) {
      console.log({mode: newValue});
    }
  }
};
</script>
<style lang="scss">
.w230 {
  .el-button {
    width: 230px;
  }
}
</style>